import {
  CollectionStore2,
  ConnectionHttpService,
  ReadonlyHttpApiCollectionRepository,
  RepositoryCollectionStore2,
  SOFTLINE_COLLECTION_REPOSITORY,
  Store2Builder,
  SubscriptionStore2
} from '@softline/core';
import { InjectionToken } from '@angular/core';
import { SOFTLINE_API_TIME_REPORT } from '@softapps/feichtinger/goldschmiede';
import { TimeReport } from '../types/time-report';

const timeReportStore = new Store2Builder('timeReport')
  .withProvider({
    provide: SOFTLINE_COLLECTION_REPOSITORY,
    useFactory: (service: ConnectionHttpService) =>
      new ReadonlyHttpApiCollectionRepository(service, SOFTLINE_API_TIME_REPORT),
    deps: [ConnectionHttpService]
  })
  .withSubFeature('subscription', SubscriptionStore2)
  .withSubFeature('collection', CollectionStore2<TimeReport>)
  .withSubFeature('collectionRemote', RepositoryCollectionStore2<TimeReport>)

export const TimeReportStore = new InjectionToken(
  'timeReportStore',
  {
    providedIn: 'root', factory: () => timeReportStore.build()
  }
)
